export const SPINNER_DELAY_MS = 300
